import { render, staticRenderFns } from "./addGoodsItem.vue?vue&type=template&id=1cc9521a&scoped=true&"
import script from "./addGoodsItem.vue?vue&type=script&lang=js&"
export * from "./addGoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./addGoodsItem.vue?vue&type=style&index=0&id=1cc9521a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc9521a",
  null
  
)

export default component.exports